module.exports = __webpack_public_path__ + "img/download-google.1eafe1c0.png";